module.exports = __webpack_public_path__ + "assets/img/c11.6ada4b35.png";